import { Payroll, PayrollEntry } from "@/types";
import { baseApi } from "../baseApi";

type PayrollResponse = {
  id: number;
  start_date: string;
  end_date: string;
  hours: number;
  pay: number;
  created_at: string;
  updated_at: string;

  entries: PayrollEntry[];
}[];

const payrollsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPayrolls: builder.query<PayrollResponse, void>({
      query: () => ({
        url: `mover/payrolls`,
      }),
    }),

    createPayroll: builder.mutation<
      Payroll,
      {
        data: {
          start_date: string;
          end_date: string;
        };
      }
    >({
      query: ({ data }) => ({
        url: `mover/payrolls`,
        method: "POST",
        body: data,
      }),
    }),

    deletePayroll: builder.mutation<void, { id: number }>({
      query: ({ id }) => ({
        url: `mover/payrolls/${id}`,
        method: "DELETE",
      }),
    }),

    getPayroll: builder.query<Payroll, { id: number }>({
      query: ({ id }) => ({
        url: `mover/payrolls/${id}`,
      }),
    }),

    getPayrollEntry: builder.query<
      PayrollEntry,
      {
        id: number;
        entryId: number;
      }
    >({
      query: ({ id, entryId }) => ({
        url: `mover/payrolls/${id}/entries/${entryId}`,
      }),
    }),

    updatePayrollEntry: builder.mutation<
      PayrollEntry,
      {
        payrollId: number;
        entryId: number;
        data: {
          tips?: number;
          bonuses?: number;
          deductions?: number;
          notes?: string;
        };
      }
    >({
      query: ({ payrollId, entryId, data }) => ({
        url: `mover/payrolls/${payrollId}/entries/${entryId}`,
        method: "PATCH",
        body: data,
      }),
    }),

    // voidTimesheet: builder.mutation<Timesheet, { id: number }>({
    //   query: ({ id }) => ({
    //     url: `mover/timesheets/${id}/void`,
    //     method: "POST",
    //   }),
    // }),

    // approveAllTimesheets: builder.mutation<Timesheet[], { ids: number[] }>({
    //   query: ({ ids }) => ({
    //     url: `mover/timesheets/approve-all`,
    //     method: "POST",
    //     body: { ids },
    //   }),
    // }),
  }),
});

export const {
  useGetPayrollsQuery,
  useCreatePayrollMutation,
  useUpdatePayrollEntryMutation,
  useGetPayrollQuery,
  useGetPayrollEntryQuery,
  useDeletePayrollMutation,
} = payrollsApi;
